import { LocalDateTime } from '../../../shared/jsr310-localdates/types/local-date-time.type';

export class MessageCollationneBase {
	dateMessage!: LocalDateTime | null;
	dateSaisie!: number[] | null;
	agentEntite!: string | null;
	correspondantEntite!: string | null;
	agentFonction!: string | null;
	correspondantFonction!: string | null;
	message!: string | null;
	correspondantNom!: string | null;
	correspondantNum!: string | null;
	agentId!: number | null;
	antenneId!: number | null;
	emetteur: boolean = true;
	parcEnConstruction!: string | null;

	constructor() {
	}
}